<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="getModelHeight"
    :title="popupConfig.title"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-maintenance-order',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <template #wo-status-template>
      <gc-status-chip :status="FriendlyStatus" v-if="FriendlyStatus" />
    </template>

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <keep-alive>
        <gc-form
          :key="popupConfig.formKey"
          :form-options="{
            gcLabelLocation: 'left',
          }"
          ref="gc-header-form"
          :form-items="getHeaderFormItems"
          :is-normal="true"
          :data-model.sync="model"
          :form-mode="popupConfig.formMode"
          :from-from="'gc-header-form-d-a'"
          :form-height="110"
          v-show="IsFormLoaded"
        />
      </keep-alive>
    </div>

    <div
      style="background-color: white"
      class="wo-data-details"
      v-if="
        popupConfig.formMode === 'edit' || popupConfig.formMode === 'review'
      "
    >
      <DxToolbar class="wo-so-toolbar" v-if="IsFormLoaded">
        <DxItem
          :options="{
            width: 'auto',
            dataSource: getTabViews,
            selectedIndex: selectedTabIndex,
            onItemClick: handleTabClick,
          }"
          location="before"
          widget="dxTabs"
        />
      </DxToolbar>

      <div>
        <!-- Processes Grid  -->
        <gcWorkOrderProcessesTab
          v-show="IsFormLoaded && selectedTabIndex === getTabIndex('Processes')"
          v-if="popupConfig.formMode !== 'create'"
          :dataModel="getDataModelForIssuesTab"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :ref="'process-tab-grid-component'"
          :popup-mode="popupConfig.formMode"
          @setFocusOnField="setFocusOnField"
          :refreshOnUpdate="refreshOnUpdate"
          :selectedTabIndex="selectedTabIndex === getTabIndex('Processes')"
        />

        <!-- Materials Grid  -->
        <gcWorkOrderMaterialsTab
          v-show="IsFormLoaded && selectedTabIndex === getTabIndex('Materials')"
          v-if="popupConfig.formMode !== 'create'"
          :dataModel="getDataModelForIssuesTab"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :ref="'materials-tab-grid-component'"
          :popup-mode="popupConfig.formMode"
          @setFocusOnField="setFocusOnField"
          :refreshOnUpdate="refreshOnUpdate"
        />
      </div>

      <GcPopupAudit
        v-if="popupAuditVisible"
        :showPopup.sync="popupAuditVisible"
        :model.sync="auditModel"
      />
    </div>
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { ProductService } from "../../_services/api/products/product.service";
import ArrayStore from "devextreme/data/array_store";
import { UserService } from "../../_services/api/settings/user/user.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import gcWorkOrderProcessesTab from "../../components/production/work-order/processes-tab.vue";
import gcWorkOrderMaterialsTab from "../../components/production/work-order/materials-tab.vue";
import { FeatureStorage } from "../../_services/storage";
import { backwardTabbing, forwardTabbing } from "../../_helpers/ui/keyboard";
import { mapGetters } from "vuex";

export default {
  mixins: [DataGridMixin],
  components: {
    gcWorkOrderProcessesTab,
    gcWorkOrderMaterialsTab,
  },
  data() {
    return {
      popupAuditVisible: false,
      Status: "D",
      StatusDataSource: [],
      IsFormLoaded: false,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
        MTSQuantity: 0,
        SOQuantity: 0,
        ReleasedQty: 0,
        AddInSalesUMQuantity: 0,
        AddInStockUMQuantity: 0,
        ReleaseDepartment: null,
      },
      mtsDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
      selectedTabIndex: 0,
      gridHeight: "auto",
      refreshOnUpdate: false,
      FriendlyStatus: "Draft",
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "MaintenanceOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    if (this.popupConfig.formMode === "create") {
      DefaultCompanyBranchDivisionService.getDefault().then((result) => {
        const defaultData = result.data.value[0];
        this.model.CompanyCode = defaultData.CompanyCode;
      });
    }

    if (
      this.popupConfig.formMode === "review" ||
      this.popupConfig.formMode === "copy"
    ) {
      const workOrderDetail = this.dataModel;
      this.model.ReleasedQty = workOrderDetail.ActualQty;
      this.model.BomCode = workOrderDetail.BomCode;
      this.model.Branch = workOrderDetail.BranchCode;
      this.model.Code = workOrderDetail.Code;
      this.model.Comments = workOrderDetail.Comment;
      this.model.CompanyCode = workOrderDetail.CompanyCode;
      this.model.Division = workOrderDetail.DivisionCode;
      this.model.Product = workOrderDetail.ProductCode;
      this.PrimaryProduct = workOrderDetail.ProductCode;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.MTSQuantity = workOrderDetail.MTSQuantity;
      this.model.SOQuantity = workOrderDetail.SalesOrderStockUMQuantity;
      this.model.ReleaseDepartment =
        workOrderDetail.ReleaseDepartmentCode +
        " - " +
        workOrderDetail.ReleaseDepartmentName;
      this.Status = workOrderDetail.Status;

      this.MTSQuantityForCopy = workOrderDetail.MTSQuantity;

      this.auditModel.createdBy = this.dataModel.CreatedBy;
      this.auditModel.dateCreated = this.dataModel.DateCreated;
      this.auditModel.changedBy = this.dataModel.ChangedBy;
      this.auditModel.dateChanged = this.dataModel.DateChanged;
      this.auditModel.dateCompleted = this.dataModel.DateCompleted;
      this.FriendlyStatus = this.dataModel.FriendlyStatus;

      this.model.QuoteCode = workOrderDetail.QuoteCode;
      this.model.Required = workOrderDetail.ShipDate;
      this.model.Scheduled = workOrderDetail.ScheduledDate;
    }

    if (
      this.FriendlyStatus === "Cancelled" ||
      this.FriendlyStatus === "Completed"
    ) {
      this.popupConfig.isEditable = false;
    } else {
      this.popupConfig.isEditable = true;
    }

    const statusConditions = {
      Cancel:
        this.dataModel.FriendlyStatus !== "Awaiting Production" &&
        this.dataModel.FriendlyStatus !== "Draft",
      Reopen:
        this.dataModel.FriendlyStatus !== "Completed" &&
        this.dataModel.FriendlyStatus !== "Cancelled",
      Complete: this.dataModel.FriendlyStatus !== "In Production",
    };

    if (this.popupConfig.formMode != "review") {
      this.getWorkOrderStatus();
    }

    this.getToolbarMenuItems.forEach((element) => {
      if (statusConditions[element.menuText] !== undefined) {
        element.disabled = statusConditions[element.menuText];
      }

      if (
        !FeatureStorage.checkPermission(this.applicationFeatureCode, "create")
      )
        element.disabled = true;
    });
  },
  methods: {
    getTabIndex(text) {
      return this.getTabViews.findIndex((x) => x.text === text);
    },
    async handleTabClick(e) {
      this.selectedTabIndex = e.itemIndex;
    },
    onPopupHide() {
      this.dataModel.Code = null;
      this.dataModel.WorkOrderCode = null;
      this.dataModel.Branch = null;

      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * on popup model shown
     */
    onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);

      this.$nextTick(() => {
        this.IsFormLoaded = true;
        let dataField = "BomCode";
        if (!this.isBOMEditable) dataField = "Required";
        setTimeout(() => this.setFocusOnField(dataField), 700);
      });
    },

    /**
     * on pop up model hide
     */

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    async getWorkOrderStatus() {
      const [statusRes, transitionRes] = await Promise.all([
        WorkOrderService.getWorkOrderStatus(),
        WorkOrderService.getWorkOrderStatusTransition(this.Status),
      ]);

      const statusArray = statusRes.data.value;
      const transitionArray = transitionRes.data.value;

      const validTransitions = transitionArray.map((t) => ({
        ToStatusCode: t.ToStatusCode,
        Sequence: t.Sequence,
      }));

      var currentStatus = statusArray.find((s) => s.Code === this.Status);

      validTransitions.push({
        ToStatusCode: currentStatus.Code,
        Sequence: currentStatus.Sequence,
      }); // ensure current status is included

      validTransitions.sort((a, b) => a.Sequence - b.Sequence);

      const toStatusCodesSet = new Set(
        validTransitions.map((t) => t.ToStatusCode)
      );

      this.StatusDataSource = Array.from(toStatusCodesSet).map((code) => {
        const status = statusArray.find((s) => s.Code === code);
        return {
          Code: status.Code,
          FriendlyStatus: status.FriendlyStatus,
          visible:
            (this.popupConfig.formMode === "create" ||
              this.popupConfig.formMode === "copy") &&
            status.FriendlyStatus === "Cancelled"
              ? false
              : true,
        };
      });
    },
    async getProductDataForAddIn(productCode, branchCode) {
      let productData = await WorkOrderService.getProductDataForAddInDataSource(
        productCode,
        branchCode
      );

      if (!productData.data || productData.data.value.length === 0) return null;

      return productData.data.value[0];
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },

    /**
     * Set Focus on Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (this.popupConfig.formMode !== "review") {
        if (
          this.$refs["gc-header-form"] &&
          this.$refs["gc-header-form"].$refs["gc-form-comp"]
        ) {
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
            .getEditor(dataField)
            .focus();
        }
      }
    },

    StatusInitialized(e) {
      let instance = e.component;
      instance.instance().beginUpdate();
      instance.instance().option("value", this.Status);
      instance.instance().endUpdate();

      this.StatusComponent = e;
    },
    onStatusValueChanged(e) {
      if (e.event) {
        this.Status = e.value;
      }
    },
    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    /**
     * On Value Changed
     * @param e
     */
    async onBomValueChanged(e) {
      if (!e.event) return;
      else {
        this.refreshOnUpdate = false;

        if (this.popupConfig.formMode === "create") {
          this.model.Quantity = 1;
        }
      }

      let instance = e.component;

      if (e.value) {
        let selectedItem = instance.getDataSource()
          ? instance
              .getDataSource()
              .items()
              .find((x) => x.Code === e.value)
          : null;

        if (!selectedItem) {
          await WorkOrderService.getBOMByCode(e.value).then((res) => {
            selectedItem = res.data.value[0];
          });
        }

        if (!selectedItem) return;
        this.updateFormValues("Branch", selectedItem.BranchCode);
        this.updateFormValues("Division", selectedItem.DivisionCode);
        this.updateFormValues("Comments", selectedItem.Comment);

        this.primaryProductData = await this.getProductDataForAddIn(
          selectedItem.ProductCode,
          selectedItem.BranchCode
        );

        await this.addMTSLineFromProduct(selectedItem);
      } else {
        this.model.Product = null;
        this.model.Comments = null;
        this.model.Branch = null;
        this.model.Division = null;
        this.primaryProductData = undefined;
      }
    },
    async addMTSLineFromProduct(selectedItem) {
      let item;
      this.mtsDataSource.clear();
      let response = await ProductService.getByCode(selectedItem.ProductCode);

      if (response.data.value.length > 0) {
        item = response.data.value[0];
      }

      if (item) {
        var newData = {};
        newData.ItemCode = item.Code;
        this.model.Product = item.Code;

        if (item) {
          newData.ItemDescription = item.Description1;
          newData.SalesUM = item.SalesUM;
          newData.StockUM = item.StockUM || item.UnitOfMeasureCode;
          newData.OnHand = item.OnHand;
          newData.OnHandSalesUMQty = item.OnHandSalesUMQty;
          newData.SalesUMConversion = item.SalesUMConversion;
          newData.RecordId = "00000000-0000-0000-0000-000000000000";
          newData.Available = item.Available;
          newData.AvailableSalesUMQty = item.AvailableSalesUMQty;
          newData.OriginalAvailable = item.Available;
          newData.OriginalAvailableSalesUMQty = item.AvailableSalesUMQty;
          newData.QtyValidation = true;
          newData.StockUMQuantity = 1;
        }

        this.$nextTick(() => {
          this.mtsDataSource.insert(newData);
        });
      }
    },
    async focusOutFromEditableCells() {
      var dataGrid = this.getDataGridInstance;
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
        if (dataGrid) dataGrid.saveEditData();
      }
    },

    async onSavePopupHandler() {
      await this.focusOutFromEditableCells();
      await this.$nextTick();

      if (this.Status === "X") {
        this.onCancelWorkOrderHandler();
      } else {
        if (this.model.BomCode === "" || this.model.BomCode === null) {
          await this.$alert("Bom Code Required", "Validation Error");
          this.setFocusOnField("BomCode");
        } else if (this.model.Required === null) {
          await this.$alert("Required Date Required", "Validation Error");
          this.setFocusOnField("Required");
        } else if (this.model.Branch === "" || this.model.Branch === null) {
          await this.$alert("Branch Required", "Validation Error");
          this.setFocusOnField("Branch");
        } else if (this.model.Division === "" || this.model.Division === null) {
          await this.$alert("Division Required", "Validation Error");
          this.setFocusOnField("Division");
        } else {
          const payload = {
            Code: this.model.Code,
            QuoteCode: this.model.QuoteCode,
            DateIn: new Date(this.model.Scheduled).toSaveDate(),
            RequiredDate: new Date(this.model.Required).toSaveDate(),
            CompanyCode: this.model.CompanyCode,
            BranchCode: this.model.Branch,
            DivisionCode: this.model.Division,
            BomCode: this.model.BomCode,
            ProductCode: this.model.Product,
            Comment: this.model.Comments,
            ItemQty: 1,
            Username: UserService.getUsername(),
            WorkOrderSalesOrderLines: [],
            WorkOrderAddIns: [],
            MTSQty: 1,
            Status: this.Status,
            WorkOrderProcesses: [],
            WorkOrderMaterials: [],
            WOType: "Maintenance",
          };

          let mtsLine = this.mtsDataSource._array.filter(
            (x) => x.ItemCode && x.StockUMQuantity >= 0
          );

          mtsLine.map((item, index) => {
            let lineItem = {
              WorkOrderCode: this.model.Code,
              SalesOrderCode: item.SalesOrderCode || 0,
              SalesOrderLine: item.SalesOrderLine || 0,
              SalesOrderStockUMQuantity: item.StockUMQuantity,
              Position: index + 1,
              ItemCode: item.ItemCode,
              // SalesOrderSalesUMQuantity: item.SalesOrderSalesUMQuantity,
              Note: "",
            };

            payload.WorkOrderSalesOrderLines.push(lineItem);
          });

          const processLines = this.$refs["process-tab-grid-component"]
            ? await this.$refs["process-tab-grid-component"].getProcessLines()
            : [];

          if (processLines.length > 0) {
            payload.WorkOrderProcesses = processLines;
          }

          const materialLines = this.$refs["materials-tab-grid-component"]
            ? await this.$refs[
                "materials-tab-grid-component"
              ].getMaterialLines()
            : [];

          if (materialLines.length > 0) {
            payload.WorkOrderMaterials = materialLines;
          }

          try {
            this.showLoading(true);
            const result = await WorkOrderService.save(payload);

            this.$notify(
              `Maintenance order #${result.data.Code} is successfully ${
                this.popupConfig.formMode === "create" ? "created" : "updated"
              }`,
              "success"
            );
            this.showLoading(false);

            this.saveCallBack();
          } catch (e) {
            this.showLoading(false);
            this.displayServerError(e, "Save Failed");
          }
        }
      }
    },
    setModelItemHeights() {
      this.$nextTick(() => {
        const popupHeight = document.querySelector(
          ".gc-popup-maintenance-order .dx-overlay-content.dx-popup-normal.dx-resizable"
        ).clientHeight;
        const toolBarHeight = document.querySelector(
          ".gc-popup-maintenance-order .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection.dx-popup-title"
        ).clientHeight;

        const headerHeight = document.querySelector(
          ".dx-popup-content .css-v2.gc-popup-form"
        ).clientHeight;

        this.gridHeight = popupHeight - toolBarHeight - headerHeight - 50;
      });
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    onEditPopupHandler() {
      this.getWorkOrderStatus();
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;

      setTimeout(() => {
        this.$nextTick(() => {
          if (this.isBOMEditable)
            setTimeout(() => this.setFocusOnField("BOM"), 50);
          else setTimeout(() => this.setFocusOnField("Required"), 50);
        });
      }, 100);
    },

    onCommentKeyDown(e) {
      if (forwardTabbing(e)) {
        e.event.preventDefault();

        if (this.popupConfig.formMode !== "create") {
          if (this.selectedTabIndex === this.getTabIndex("Processes")) {
            const instance =
              this.$refs["process-tab-grid-component"].$refs["process-tab-grid"]
                .instance;
            if (instance) {
              const dataSource = instance.option("dataSource");
              if (dataSource && dataSource.length > 0) {
                const firstRow = dataSource[0];
                if (firstRow) {
                  if (firstRow.IsDeletable === "Y") {
                    this.$refs[
                      "process-tab-grid-component"
                    ].focusOnEditableCell(0, "ProcessCode");
                  } else {
                    this.$refs[
                      "process-tab-grid-component"
                    ].focusOnEditableCell(0, "RatePerHour");
                  }
                }
              }
            }
          } else if (this.selectedTabIndex === this.getTabIndex("Materials")) {
            const instance =
              this.$refs["materials-tab-grid-component"].$refs[
                "materials-tab-grid"
              ].instance;

            if (instance) {
              const dataSource = instance.option("dataSource");
              if (dataSource && dataSource.length > 0) {
                const firstRow = dataSource[0];
                if (firstRow) {
                  if (firstRow.IsEditable) {
                    this.$refs[
                      "materials-tab-grid-component"
                    ].focusOnEditableCell(0, "ProcessCode");
                  } else {
                    this.$refs[
                      "materials-tab-grid-component"
                    ].focusOnEditableCell(0, "WorkOrderQty");
                  }
                }
              }
            }
          }
        }
      } else if (backwardTabbing(e)) {
        e.event.preventDefault();
        this.setFocusOnField("Required", true, false);
      }
    },

    /**
     * On Cancel Work Order
     */
    async onCancelWorkOrderHandler() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this maintenance order?",
        "Cancel Maintenance Order"
      );

      if (confirmCancel) {
        this.onCancelWorkOrder();
      }
    },
    async onCancelWorkOrder() {
      this.showLoading(true);
      await WorkOrderService.cancelWorkOrder({
        Code: this.dataModel.Code.toString(),
        DateChanged: new Date().toISOString().replace("Z", ""),
      })
        .then((res) => {
          if (res)
            this.$notify(
              `Maintenance Order #${this.dataModel.Code} Successfully Cancelled`,
              "success"
            );
          this.showLoading(false);
          this.saveCallBack();
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err, "Cancel Maintenance Order Failed");
        });
    },

    /**
     * On Reopen Work Order Handler
     */
    async onReopenWorkOrderHandler() {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this maintenance order?",
        "Re-Open Maintenance Order"
      );

      if (confirmReOrder) {
        this.showLoading(true);
        await WorkOrderService.reopenWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Maintenance Order #${this.dataModel.Code} Successfully Re-Opened.`,
                "success"
              );
            this.showLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Re-Open Maintenance Order Failed");
          });
      }
    },

    /**
     * On Copy Work Order
     */
    async onCopyWorkOrderHandler() {
      this.showLoading(true);
      this.IsFormLoaded = false;
      this.dataModel.FriendlyStatus = "Draft";
      this.FriendlyStatus = "Draft";
      this.Status = "D";

      this.popupConfig.formMode = "copy";

      if (this.$refs["materials-tab-grid-component"]) {
        this.$refs[
          "materials-tab-grid-component"
        ].workOrderMaterialDataSource.clear();
      }

      if (this.$refs["process-tab-grid-component"]) {
        this.$refs["process-tab-grid-component"].processDataSource.clear();
      }

      await this.getWorkOrderStatus();

      this.$nextTick(async () => {
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
        // this.FriendlyStatus = undefined;
        this.popupConfig.title = "Create Maintenance Order";
        this.popupConfig.secondaryTitle = undefined;
        this.popupConfig.hideOnOutsideClick = false;
        this.popupConfig.formKey++;
        this.popupConfig.isEditable = true;

        if (this.getDataGridInstance) {
          this.getDataGridInstance.refresh();
        }

        this.$nextTick(() => {
          this.IsFormLoaded = true;
          this.showLoading(false);
          setTimeout(() => {
            this.setFocusOnField("Required");
          }, 1);
        });
      });
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getDataModelForIssuesTab() {
      return {
        WorkOrderCode: this.dataModel.Code,
        BranchCode: this.dataModel.Branch,
        WorkOrderStatus: this.dataModel.FriendlyStatus,
      };
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "center",
          visible: this.popupConfig.formMode === "review",
          cssClass: "status-template-2",
          options: {
            template: "wo-status-template",
            elementAttr: { class: "status-template" },
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },

        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            this.popupConfig.isEditable &&
            FeatureStorage.checkPermission(
              this.applicationFeatureCode,
              "create"
            ),
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
            visible:
              this.popupConfig.isEditable &&
              this.popupConfig.formMode === "review",
          },
        },
        {
          widget: "dxSelectBox",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            items: this.getStatusDataSource,
            displayExpr: "FriendlyStatus",
            valueExpr: "Code",
            readOnly: false,
            onValueChanged: this.onStatusValueChanged,
            onInitialized: this.StatusInitialized,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            items: this.getToolbarMenuItems,
            icon: "fas fa-ellipsis-v",
            showArrowIcon: false,
            stylingMode: "text",
            onItemClick: this.onToolbarMenuItemOnClick,
            dropDownOptions: {
              minWidth: 90, // Set minimum width for dropdown items
            },
            displayExpr: "menuText",
            valueExpr: "menuText",
          },
        },
      ];
    },

    getToolbarMenuItems() {
      return [
        {
          menuText: "Copy",
          visible: true, // pending discussions #54331
          onClick: this.onCopyWorkOrderHandler,
        },
        // { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler }, // Remove #59851
        { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        // { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },  // Remove #59851
      ];
    },
    getStatusDataSource() {
      return this.StatusDataSource;
    },

    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField: "BOM",
                  dataField: "BomCode",
                  required: true,
                  label: {
                    text: "BOM",
                  },
                  editorOptions: {
                    showClearButton: true,
                    readOnly: !this.isBOMEditable,
                    onValueChanged: this.onBomValueChanged,
                    select: [
                      "Code",
                      "Comment",
                      "Description1",
                      "Description2",
                      "ProductCode",
                      "BatchSize",
                      "BranchCode",
                      "DivisionCode",
                      "BomTypeCode",
                      "Status",
                    ],
                    filter:
                      this.popupConfig.formMode === "edit"
                        ? ["ProductCode", "=", this.PrimaryProduct]
                        : [
                            ["BomTypeCode", "=", "Maintenance"],
                            "and",
                            ["Status", "=", "A"],
                          ],
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description1}`;
                    else return undefined;
                  },
                  searchExpr: [
                    "Code",
                    "Description1",
                    "Description2",
                    "ProductCode",
                  ],
                },
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  required: true,
                  label: {
                    text: "Branch",
                  },
                  filter: ["ManufactureFlag", "=", "Y"],
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: !this.isBranchEditable,
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description}`;
                    else undefined;
                  },
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  required: true,
                  label: {
                    text: "Division",
                  },
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: !this.isDivisionEditable,
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description}`;
                    else undefined;
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField: "DateIn",
                  dataField: "Required",
                  label: {
                    text: "Required",
                  },
                  format: "dd MMM yyyy",
                  editorOptions: {
                    showClearButton: true,
                    useMaskBehavior: true,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    readOnly:
                      this.popupConfig.formMode === "edit" &&
                      this.dataModel.FriendlyStatus === "In Production",
                  },
                  required: true,
                },
                {
                  dataField: "Comments",
                  screenField: "Comments",
                  allowUpdate: true,
                  editorType: "dxTextArea",
                  editorOptions: {
                    height: 60,
                    maxLength: 1000,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: this.onCommentKeyDown,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    isDivisionEditable() {
      return (
        this.popupConfig.formMode === "edit" &&
        (this.dataModel.FriendlyStatus === "Draft" ||
          this.dataModel.FriendlyStatus === "Awaiting Production" ||
          this.dataModel.FriendlyStatus === "Planning")
      );
    },

    isBOMEditable() {
      return (
        this.popupConfig.formMode === "create" ||
        (this.popupConfig.formMode === "edit" &&
          (this.dataModel.FriendlyStatus === "Draft" ||
            this.dataModel.FriendlyStatus === "Awaiting Production" ||
            this.dataModel.FriendlyStatus === "Planning"))
      );
    },
    isBranchEditable() {
      return (
        this.popupConfig.formMode === "edit" &&
        (this.dataModel.FriendlyStatus === "Draft" ||
          this.dataModel.FriendlyStatus === "Awaiting Production" ||
          this.dataModel.FriendlyStatus === "Planning")
      );
    },

    getModelHeight() {
      return this.popupConfig.formMode === "edit" ||
        this.popupConfig.formMode === "review"
        ? "75%"
        : 212;
    },

    getDataGridInstance() {
      if (this.$refs["maintenance-grid"])
        return this.$refs["maintenance-grid"].instance;
      else return null;
    },

    getTabViews() {
      return [
        {
          id: 1,
          text: "Processes",
        },
        {
          id: 2,
          text: "Materials",
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") {
            this.onSavePopupHandler();
          }
        }
      },
      deep: true,
    },
    IsFormLoaded: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.setModelItemHeights();
          }, 500);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-maintenance-order {
  .hyperlink.negative a {
    color: red !important;
  }

  .hyperlink.zero a {
    color: black !important;
  }
  .status-template {
    display: flex;
    align-items: center;
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: white;
    margin: 0px 10px;

    .wo-so-toolbar {
      .add-new-btn {
        .dx-button {
          background-color: unset !important;
          .dx-button-content .dx-icon::before {
            color: #344054 !important;
          }

          .dx-button-text {
            padding-right: unset !important;
          }
        }

        margin-right: 10px;
        background: var(
          --Component-colors-Components-Buttons-Secondary-button-secondary-bg,
          #ffffff
        );
        border: 1px solid
          var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-border,
            #d0d5dd
          );
        box-shadow: 0px 1px 2px 0px #1018280d;

        .dx-icon.dx-icon-plus::before {
          color: #344054 !important;
        }

        .dx-button-text {
          font-family: Inter;
          font-weight: 600;
          font-size: 12px;
          // line-height: 20px;
          letter-spacing: 0%;
          color: var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-fg,
            #344054
          );
        }
      }
    }
  }
  .dx-datagrid-header-panel {
    height: 0px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .process-code {
    padding-left: 10px !important;
  }

  .os-qty {
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-editor-cell.dx-focused {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .wo-data-header {
    background-color: white;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    gap: 10px;

    > div {
      // width: 100%;

      .dx-datagrid-header-panel {
        height: 0px !important;
      }

      .dx-scrollable-wrapper > .dx-scrollable-container {
        overflow-y: hidden !important;
      }
    }
  }
}
</style>
